export default {
      id: "circle__BLE-disconnect-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "img/icons.svg#circle__BLE-disconnect",
      toString: function () {
        return this.url;
      }
    }